// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Uq-z","giftOrPromoSelector":"Vq-z","disabled":"Wq-z","subTitle":"Xq-z","selectShipAddressMessage":"Yq-z","changePayment":"Zq-z"};